
<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li><a routerLink="/products/regimens">Regimens</a></li>
          <li>{{regimenObj?.get('regimenId')}}</li>
        </ul>
        <div class="pull-right"><span *ngFor="let variant of variants;">
            <button class="btn-xs ml-1 mr-1" (click)="displayVariant(variant)" [ngClass]="{'btn-primary': selectedVariant.variantId == variant.variantId, 'btn-primary-outline': selectedVariant.variantId !== variant.variantId }">{{variant.variantId}}</button></span><span class="ml-3" *ngIf="userRoles.includes('regimenEditor')">
            <button class="btn-xs btn-primary-outline" *ngIf="[apiClientConstant.Regimen.Type.MAIN, apiClientConstant.Regimen.Type.PERSONALIZED].includes(regimenObj.get('type'))" routerLink="../../regimen/{{regimenObj.get('regimenId')}}/edit">Edit</button>
            <button class="btn-xs btn-primary-outline ml-2" *ngIf="regimenObj.get('type') === apiClientConstant.Regimen.Type.ALTERNATE" routerLink="../../alternate/{{regimenObj.get('regimenId')}}/edit">Edit</button>
            <button class="btn-xs btn-primary-outline ml-2" *ngIf="userRoles.includes('regimenEditor')" (click)="copyRegimen()">Copy</button>
            <button class="btn-xs btn-primary-outline ml-2" *ngIf="regimenObj.get('type') === apiClientConstant.Regimen.Type.MAIN" routerLink="../../regimens/new">New</button>
            <button class="btn-xs btn-primary-outline ml-2" *ngIf="regimenObj.get('type') === apiClientConstant.Regimen.Type.ALTERNATE" routerLink="../../alternates/new">New</button>
            <button class="btn-xs btn-primary-outline ml-2"><a href="{{conn.getWebAppUrl()}}/user?tab=regimen&amp;username={{user.get('username')}}&amp;regimenId={{regimenObj.get('regimenId')}}" target="_blank">View</a></button></span></div>
      </div>
    </div>
    <div class="flex-content">
      <div class="col-xs-12 p-4">
        <div class="col-xs-12 flex mt-0 mb-4" *ngIf="voiceIdentifier && isOperatorRolePresent">
          <label class="col-xs-3">Instruction Voice</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8 flex">
            <button class="btn btn-xs mr-1" *ngIf="enbaleResendVoiceInstruction" (click)="sendVoiceInstruction()">Send To User</button>
            <language-voice-recorder [identifier]="voiceIdentifier" [language]="voiceLanguage" (recordingURL)="enbaleResendVoiceInstruction = true"></language-voice-recorder>
          </div>
        </div>
        <div class="col-xs-12 flex mt-0">
          <label class="col-xs-2">Regimen Id</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('regimenId')}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Products</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8"><a class="inline product-label night" *ngFor="let product of selectedVariant.products;" routerLink="/products/catalog/{{product.id}}">{{product.get('title')}} &nbsp; [{{product.get('quantity')}}{{product.get('quantityUnit')}}] {{product.get('type') === apiClientConstant.Catalog.Type.SAMPLE ? '(SAMPLE)' : '' }}</a></div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Skin Type</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('skinType')}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Sample Available</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('sampleAvailable') ? 'YES' : 'NO'}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Approval Percentage</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{selectedVariant.approvalPercentage}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Fixed Price</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{selectedVariant.fixedPrice}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Number Of Products Limit</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{selectedVariant.numberOfProductsLimit}}</div>
        </div>
        <div class="col-xs-12 flex" *ngIf="regimenObj.get('class')">
          <label class="col-xs-2">Regimen Class</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('class')}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Concern</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">
            <language-view [languageStringObj]="this.regimenObj.get('concernsLanguageString')"></language-view>
          </div>
        </div>
        <div class="col-xs-12 flex" *ngIf="regimenObj.get('whatToExpect')">
          <label class="col-xs-2">What to expect</label>
          <div class="col pull-left mt-3">:</div>
          <div class="col-xs-8 mt-3">{{regimenObj.get('whatToExpect')}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Duration</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('durationInWeek')}} Weeks</div>
        </div>
        <div class="col-xs-12 mt-3">
          <label class="col-xs-2">Morning</label>
          <div class="col-xs-8 mt-3">
            <div class="col-xs-12">
              <ul class="nav">
                <li *ngFor="let item of selectedVariant.morning; let i = index;">
                  <div class="col-xs-12 product-morning-view">
                    <label class="col-xs-12 pl-0 mt-0 fontL1">{{item.product.get('title')}} ({{item.purpose}}) [{{item.product.get('quantity')}}{{item.product.get('quantityUnit')}}] {{item.product.get('type') === apiClientConstant.Catalog.Type.SAMPLE ? ('(' + item.product.get('type').toUpperCase() + ')') : ''}}</label>
                    <div class="col-xs-12 p-3 pl-0 b-t" *ngIf="item.purposeDescription">{{item.purposeDescription}}</div>
                    <div *ngIf="item.instructionSet && regimenObj.get('showSummaryView')">
                      <catalog-instruction-view [instruction]="item.instructionSet" [type]="apiClientConstant.Order.Type.REGIMEN"></catalog-instruction-view>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xs-12 mt-3">
          <label class="col-xs-2 mt-3">Night</label>
          <div class="col-xs-8 mt-3">
            <ul class="nav">
              <li *ngFor="let item of selectedVariant.night; let i = index;">
                <div class="col-xs-12 product-night-view">
                  <label class="col-xs-12 pl-0 fontL1 mt-0">{{item.product.get('title')}} ({{item.purpose}}) [{{item.product.get('quantity')}}{{item.product.get('quantityUnit')}}] {{item.product.get('type') === apiClientConstant.Catalog.Type.SAMPLE ? ('(' + item.product.get('type').toUpperCase() + ')') : ''}}</label>
                  <div class="col-xs-12 p-3 pl-0 b-t" *ngIf="item.purposeDescription">{{item.purposeDescription}}</div>
                  <div *ngIf="item.instructionSet && regimenObj.get('showSummaryView')">
                    <catalog-instruction-view [instruction]="item.instructionSet" [type]="apiClientConstant.Order.Type.REGIMEN"></catalog-instruction-view>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-xs-12 flex" *ngIf="regimenObj.get('dietAndLifestyleQuestion')">
          <label class="col-xs-2">Diet And Lifestyle</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get("dietAndLifestyleQuestion").get('title')}}</div>
        </div>
        <div class="col-xs-12 flex" *ngIf="investigation">
          <label class="col-xs-2">Investigation</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">
            <span class="fontL1">{{investigation.get('name')}}</span>
            <ul class="pl-4 mt-1 mb-0">
              <li *ngFor="let test of investigation.get('tests')">{{test.test}}</li>
            </ul>
          </div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Products Price</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenPrice()}} Rs.</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Discount</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get("discount")}}%</div>
        </div>
        <div class="col-xs-12 flex" *ngIf="regimenObj.get('endDate')">
          <label class="col-xs-2">End Date</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get("endDate")| amDateFormat: 'MMM DD, YYYY'}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Note (Not Visible To User)</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get("note") || '-'}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Active</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8">{{regimenObj.get('active') ? 'YES' : 'NO'}}</div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Regimen Link</label>
          <div class="col pull-left">:</div>
          <div class="col-xs-8"><a href="{{conn.getWebAppUrl()}}/user/?tab=regimen&amp;username={{user.get('username')}}&amp;regimenId={{regimenObj.get('regimenId')}}" target="_blank">Click To View</a></div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Regimen Cover Image</label>
          <div class="col pull-left mt-3">:</div>
          <div class="mt-3"><img data-testid="regimen-cover-image" style="padding-left:15px" height="100px" widht="100px" src="{{selectedVariant.regimenCoverImage}}"/></div>
        </div>
        <div class="col-xs-12 flex">
          <label class="col-xs-2">Progressive Info Products</label>
          <div class="col pull-left mt-3">:</div>
          <div class= "col-xs-12 mt-3">
            <div *ngFor="let product of progressiveInfoProducts">
              <div class="flex items-center mt-0">
                <p class="fontL1 bold-500 mt-2">Name : </p>
                <span class="ml-2">{{product.title}}</span>
              </div>
              <div class="flex items-center mt-0">
                <p class="fontL1 bold-500 mt-2">Start After Day Of Delivery: </p>
                <span class="ml-2">{{product.startAfterDayOfDelivery}}</span>
              </div>
              <div class="flex items-center mt-0">
                <p class="fontL1 bold-500 mt-2">End After Day Of Delivery: </p>
                <span class="ml-2">{{product.endAfterDayOfDelivery}}</span>
              </div>
              <div class="flex items-center mt-0">
                <p class="fontL1 bold-500 mt-2">Action: </p>
                <span class="ml-2">{{product.action}}</span>
              </div>
              <div class="flex items-center mt-0">
                <p class="fontL1 bold-500 mt-2">Status: </p>
                <span class="ml-2">{{product.status}}</span>
              </div>
              @if (product.status === apiClientConstant.ProgressiveTreatment.Status.REJECTED) {
                <div class="flex items-center mt-0">
                  <p class="fontL1 bold-500 mt-2">Reason: </p>
                  <span class="ml-2">{{product.note}}</span>
                </div>
              }
              <div class="col-xs-10 mt-0" *ngIf="product.action === apiClientConstant.ProgressiveTreatment.Action.ADD_TO_BANNER_WITH_REGIMEN_CHANGE">
                <catalog-instruction-view [instruction]="product.productInfo.instructionSet"></catalog-instruction-view>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 no-padder my-3">
        <div class="col-xs-12 list-header mb-2 pl-4 pointer" (click)="onRegimenChangesBarClick()">Change in Regimen</div>
        <ng-container *ngIf="showRegimenChanges">
          <div class="col-xs-12" style="height:250px; overflow-y:scroll" #actionLogScrollContainer (scroll)="onScrollActionLog()">
            <div class="col-xs-12 pl-4 my-2" *ngFor="let item of actionLog;">
              <div class="col-xs-4">{{item.get('Action')}}</div>
              <div class="col-xs-4">{{item.get("createdAt")| amDateFormat: 'MMM DD, YYYY hh:mm a'}}</div>
              <div class="col-xs-4">{{item.get('ByUser') ? item.get('ByUser').get('username') : ''}}</div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-xs-12 no-padder my-3">
        <div data-testid="regimen-history-toggle" class="col-xs-12 list-header mb-2 pl-4 pointer" (click)="onRegimenHistoryBarClick()">Regimen History</div>
        <ng-container *ngIf="showRegimenHistory">
          <div class="col-xs-12" #regimenHistoryScrollContainer style="height:250px; overflow-y:scroll" (scroll)="onScrollRegimenHistory()">
            <div class="col-xs-12 pl-4" *ngFor="let item of regimenHistory;">
              <div class="col-xs-2"><a class="text-info pointer" href="products/regimen/history/{{item.id}}" target="_blank">{{item.get("createdAt")| amDateFormat: 'MMM DD, YYYY hh:mm a'}}</a></div>
              <div class="col-xs-10 scroll">
                <morning-night-list [regimen]="item"></morning-night-list>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-xs-12 no-padder my-3" *ngIf="regimenObj.get('type') === apiClientConstant.Regimen.Type.MAIN">
        <div class="col-xs-12 list-header mb-2 pl-4">Alternative Regimens<i class="fas fa-plus-square ml-3 pointer" routerLink="alternates/new" *ngIf="userRoles.includes('regimenEditor')"></i></div>
        <div class="col-xs-12 no-padder pl-4" *ngFor="let alternateRegimen of alternateRegimens; let i = index;">
          <div class="col-xs-12 my-2"><span class="text-info pointer" routerLink="alternate/{{alternateRegimen.get('regimenId')}}">{{alternateRegimen.get('regimenId')}} (active: {{alternateRegimen.get('active')}}) &nbsp;&nbsp;</span><a class="fa fa-pencil-square-o pointer m-l-xs" routerLink="alternate/{{alternateRegimen.get('regimenId')}}/edit" target="_blank"></a></div>
        </div>
      </div>
      <div class="col-xs-12 no-padder my-3" *ngIf="isMainRegimen">
        <div class="col-xs-12 list-header mb-2 pl-4">Trees Having this regimen</div>
        <div class="col-xs-12 my-2 pl-4" *ngFor="let tree of treesHavingThisRegimen;"><a class="text-info" routerLink="/tree/{{tree.get('version')}}/{{tree.get('type').toLowerCase()}}/{{tree.get('name')}}">
            <div class="col-xs-12"></div>{{tree.get('name')}}</a></div>
      </div>
    </div>
  </div>
</div>
